import React from 'react';
import './Work.scss';

import { SiDotNet, SiMongodb } from 'react-icons/si';
import { FaNodeJs, FaReact, FaVrCardboard, FaAndroid, FaGraduationCap, FaBeer } from 'react-icons/fa';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { withOrientationChange } from 'react-device-detect'

const Work = React.forwardRef((props: any, ref) => {
    const { isLandscape } = props

    return (
        <VerticalTimeline animate={isLandscape}>
            <VerticalTimelineElement
                id="first-work"
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'transparent', border: '2px solid white', color: '#fff' }}
                contentArrowStyle={{ borderRight: '0' }}
                date="2020 - present"
                iconStyle={{ background: '#512bd4', color: '#fff' }}
                icon={<SiDotNet />}>
                <div className="vertical-timeline-element--content" ref={ref as React.RefObject<HTMLDivElement>}>
                    <h3 className="work-header">Senior Software Engineer</h3>
                    <h4 className="work-subheader"><a className="subtle-link" href="https://www.datasnipper.com">DataSnipper</a></h4>
                    <p className="work-description">.NET &nbsp;&middot;&nbsp; C# &nbsp;&middot;&nbsp; Node.JS &nbsp;&middot;&nbsp; Office Add-in &nbsp;&middot;&nbsp; Microsoft VSTO</p>
                </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'transparent', border: '2px solid white', color: '#fff' }}
                contentArrowStyle={{ borderRight: '0' }}
                date="2019-2020"
                iconStyle={{ background: '#333', color: '#689f63' }}
                icon={<FaNodeJs />}>
                <div className="vertical-timeline-element--content">
                    <h3 className="work-header">Lead Developer</h3>
                    <h4 className="work-subheader"><a className="subtle-link" href="https://www.learned.io">Learned.io</a></h4>
                    <p className="work-description">Node.JS &nbsp;&middot;&nbsp; MongoDB &nbsp;&middot;&nbsp; React &nbsp;&middot;&nbsp; TypeScript</p>
                </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'transparent', border: '2px solid white', color: '#fff' }}
                contentArrowStyle={{ borderRight: '0' }}
                date="2018 - 2019"
                iconStyle={{ background: '#333', color: '#689f63' }}
                icon={<FaNodeJs />}>
                <div className="vertical-timeline-element--content">
                    <h3 className="work-header">Full Stack Developer</h3>
                    <h4 className="work-subheader"><a className="subtle-link" href="https://www.caceis.com/nl/">KAS BANK (Caceis)</a></h4>
                    <p className="work-description">Node.JS &nbsp;&middot;&nbsp; Angular &nbsp;&middot;&nbsp; Ethereum &nbsp;&middot;&nbsp; Blockchain &nbsp;&middot;&nbsp; MongoDB</p>
                </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'transparent', border: '2px solid white', color: '#fff' }}
                contentArrowStyle={{ borderRight: '0' }}
                date="2018"
                iconStyle={{ background: '#fff', color: '#13aa52' }}
                icon={<SiMongodb />}>
                <div className="vertical-timeline-element--content">
                    <h3 className="work-header">Backend Developer</h3>
                    <h4 className="work-subheader"><a className="subtle-link" href="https://www.npmjs.com/package/typegoose-cursor-pagination">Typegoose Cursor-based Pagination</a></h4>
                    <p className="work-description">TypeScript &nbsp;&middot;&nbsp; MongoDB &nbsp;&middot;&nbsp; Open Source</p>
                </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'transparent', border: '2px solid white', color: '#fff' }}
                contentArrowStyle={{ borderRight: '0' }}
                date="2017 - 2018"
                iconStyle={{ background: '#222222', color: '#61dafb' }}
                icon={<FaReact />}>
                <div className="vertical-timeline-element--content">
                    <h3 className="work-header">Frontend Developer</h3>
                    <h4 className="work-subheader"><a className="subtle-link" href="https://www.lequest.com">LeQuest</a></h4>
                    <p className="work-description">React &nbsp;&middot;&nbsp; JavaScript &nbsp;&middot;&nbsp; Entity Component System</p>
                </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'transparent', border: '2px solid white', color: '#fff' }}
                contentArrowStyle={{ borderRight: '0' }}
                date="2017 - 2019"
                iconStyle={{ background: '#333', color: '#fff' }}
                icon={<FaVrCardboard />}>
                <div className="vertical-timeline-element--content">
                    <h3 className="work-header">IT Consultant</h3>
                    <h4 className="work-subheader"><a className="subtle-link" href="https://www.ordina.nl/en/">Ordina</a></h4>
                    <p className="work-description">AR / VR &nbsp;&middot;&nbsp; Full Stack &nbsp;&middot;&nbsp; Blockchain &nbsp;&middot;&nbsp; Mobile</p>
                </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'transparent', border: '2px solid white', color: '#fff' }}
                contentArrowStyle={{ borderRight: '0' }}
                date="2015 - 2017"
                iconStyle={{ background: '#e5cf1e', color: '#fff' }}
                icon={<FaGraduationCap />}>
                <div className="vertical-timeline-element--content">
                    <h3 className="work-header">Master of Science</h3>
                    <h4 className="work-subheader"><a className="subtle-link" href="https://www.uu.nl/en">Utrecht University</a></h4>
                    <p className="work-description">Computer Science &nbsp;&middot;&nbsp; Game and Media Technology</p>
                </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'transparent', border: '2px solid white', color: '#fff' }}
                contentArrowStyle={{ borderRight: '0' }}
                date="2015 - 2016"
                iconStyle={{ background: '#3dda84', color: '#fff' }}
                icon={<FaAndroid />}>
                <div className="vertical-timeline-element--content">
                    <h3 className="work-header">Co-Founder &nbsp;&middot;&nbsp; Mobile Developer</h3>
                    <h4 className="work-subheader">Apps At Work</h4>
                    <p className="work-description">Mobile &nbsp;&middot;&nbsp; Android &nbsp;&middot;&nbsp; UWP &nbsp;&middot;&nbsp; Java &nbsp;&middot;&nbsp; .NET</p>
                </div>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'transparent', border: '2px solid white', color: '#fff' }}
                contentArrowStyle={{ borderRight: '0' }}
                date="2012 - 2015"
                iconStyle={{ background: '#e5cf1e', color: '#fff' }}
                icon={<FaGraduationCap />}>
                <div className="vertical-timeline-element--content">
                    <h3 className="work-header">Bachelor of Science</h3>
                    <h4 className="work-subheader"><a className="subtle-link" href="https://www.uu.nl/en">Utrecht University</a></h4>
                    <p className="work-description">Computer Science</p>
                </div>
            </VerticalTimelineElement>
            
            <VerticalTimelineElement
            iconStyle={{ background: '#081D44', color: '#fff' }}
            icon={<FaBeer />}
            />
      </VerticalTimeline>
    );
  });
  
  export default withOrientationChange(Work);
  